module.exports = __webpack_public_path__ + "e276e49959cfab2090f0b1f509b5d55f.svg";